module.exports = __webpack_public_path__ + "img/idcard1.9222fd60.png";